import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const handlingUnitValidator = (maxValue: number = 99999): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    const normalizedValue = String(value).trim();

    // A whitespace-only value is also considered empty
    if (normalizedValue === '') {
      return null;
    }

    // Letters, symbols, decimals, negative numbers and zero
    if (!/^[1-9]\d*$/.test(normalizedValue)) {
      return {
        greaterThanOrEqualToOne: true,
      };
    }

    if (Number(normalizedValue) > maxValue) {
      return {
        max: {
          max: maxValue,
          actual: Number(normalizedValue),
        },
      };
    }

    return null;
  };
};
